import React, { useEffect } from "react";
import { PublicLayout } from "../components/public/PublicLayout";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Sambiva (GST Foods) is committed to protecting your personal data in line with the GDPR.",
    sections: [
      ["Who we are", "Sambiva is a brand of GST Foods, Rua das Olarias, Number 10, 6000-176 Castelo Branco, Portugal."],
      ["Data we collect", "We collect information you provide through contact forms and trade account applications, including your name, company, contact details and VAT ID."],
      ["How we use it", "We use your data to respond to enquiries, evaluate trade applications and manage trade accounts. Transactional communications are separate from marketing. We never subscribe trade applicants to marketing automatically."],
      ["Your rights", "You may request access, correction or deletion of your data at any time by contacting hello@sambiva.com."],
    ],
  },
  cookies: {
    title: "Cookie Policy",
    intro: "This site uses only essential cookies required for authentication and language preferences.",
    sections: [
      ["Essential cookies", "We use secure cookies to keep you signed in to the trade and admin portals and to remember your language choice."],
      ["Analytics", "We do not use third-party advertising cookies. Any analytics used are privacy-friendly and aggregated."],
      ["Managing cookies", "You can clear cookies at any time via your browser settings."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "These terms govern your use of the Sambiva website and trade portal.",
    sections: [
      ["Use of the site", "The consumer website is provided for information and product discovery. Product availability varies by retailer."],
      ["Trade accounts", "Trade accounts are subject to approval. Wholesale pricing and stock information are confidential and available only to approved partners."],
      ["Orders", "All trade orders are subject to availability and confirmation. Prices are calculated at the time of order."],
      ["Governing law", "These terms are governed by the laws of Portugal."],
    ],
  },
};

export function LegalPage({ page }) {
  const c = CONTENT[page];
  useEffect(() => { document.title = `${c.title} | Sambiva`; }, [c.title]);
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-serif text-4xl text-sambiva-charcoal mb-4">{c.title}</h1>
        <p className="text-sambiva-muted text-lg mb-10">{c.intro}</p>
        <div className="space-y-8">
          {c.sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="font-serif text-xl text-sambiva-charcoal mb-2">{h}</h2>
              <p className="text-sambiva-muted leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
